<!-- 输入区域 -->
<template>
    <div class="input">
        <span class="input-text">输入区</span>
        <div class="input-example" @click.stop="handleExampleClick">输入示例</div>
        <textarea
            class="clearfix input-content"
             v-model="inputText"/>
        <example ref="example"/>
    </div>
</template>

<script>
import { QUESTION_TITLE, QUESTION_VAL } from "@/utils/question-config";
import Example from "./example";
import ResponsibilityChain from "@/utils/responsibility-chain";
import { valueEquals } from "element-ui/src/utils/util"
import { uuid } from "@/utils";

export default {
    name: "CreateTextImportText",
    components: {
        Example
    },
    data() {
        return {
            inputText: "", // 输入区域文本
        }
    },
    watch: {
        inputText(val) {
            // 由行组成的数组 过滤掉一行中全为空字符的行，替换掉一行中的空字符串，得到有效行组成的数组
            const validLineArray = val.split(/(\n|\r|\r\n|↵)/g)
                .filter(str => /\s*(\S+)\s*$/g.test(str))
                .map(str => str.replace(/\s+/g, ""))
            if (validLineArray.length === 0) {
                // 重置责任链
                this.chain = undefined
                this.matchTitle(validLineArray)
                return
            }
            // 优化了下，如果上次有效行和这次有效行相等就不干任何事情
            if (valueEquals(this.validLineArray, validLineArray)) return;
            this.validLineArray = validLineArray
            // 责任链模式-- 第一步匹配项目标题
            const chain = new ResponsibilityChain(this.matchTitle, "matchTitle", 1, validLineArray)
            this.chain = chain
                // 第二步匹配欢迎语
                .syncNext(this.matchWelcome, "matchWelcome")
                // 第三部匹配试题
                .syncNext(this.matchQuestion, "matchQuestion")
                // 结束
                .syncEnd(false)
        },
    },
    methods: {
        handleExampleClick() {
            this.$refs.example.open()
        },
        // 重置所有状态
        initStatus() {
            this.stemStr = "" // 重置题干
            // 问卷试题列表
            this.questionList = Object.keys(QUESTION_VAL).reduce((preVal, curVal) => {
                preVal[QUESTION_VAL[curVal]] = []
                return preVal
            }, Object.create(null))
            this.questionStatus = undefined // 重置试题状态
        },
        // 过滤掉标示符
        filterMarking(str, mark) {
            const reg = new RegExp(String.raw`【${mark}】`, "g")
            return str.replace(reg, "")
        },
        // 匹配项目标题
        matchTitle(validLines) {
            this.$emit("matchTitle", validLines[0] || "")
            return validLines.length > 1 ? validLines.slice(1) : false
        },
        // 匹配项目欢迎语
        matchWelcome(validLines) {
            // 欢迎语索引
            const welcomeIndex = validLines.findIndex(item => item.endsWith("【欢迎语】"))
            const val = welcomeIndex > -1 ? this.filterMarking(validLines.slice(0, welcomeIndex + 1).join(""), "欢迎语") : validLines.join("")
            this.$emit("matchWelcome", val)
            return (welcomeIndex > -1 && welcomeIndex < validLines.length - 1) ? validLines.slice(welcomeIndex + 1) : false
        },
        // 匹配问卷试题
        matchQuestion(validLines) {
            const {
                single,
                multiple,
                filling
            } = QUESTION_TITLE
            const endFn = (str, name) => str.endsWith(`【${name}】`)
            const alertMessage = (str) => {
                const titles = Object.values(QUESTION_TITLE)
                const isAlert = titles.some(title => {
                    return !endFn(str, title) && str.includes(`【${title}】`)
                })
                if (isAlert) this.$message.error("题干必须以" + titles.map(item => `【${item}】`).join("，") + "结尾")
            }
            // 消费掉的行
            let consumeLines = 1
            // 用户给试题排序的下标
            let orderIndex = 0
            // 是否提示
            let alert = true
            // 初始化状态
            this.initStatus()
            while (validLines.length > 0) {
                const str = validLines[0]
                orderIndex = orderIndex + 1
                switch (true) {
                case endFn(str, single):
                    consumeLines = this.matchQuestionOfSingle(validLines, orderIndex)
                    break;
                case endFn(str, multiple):
                    consumeLines = this.matchQuestionOfMultiple(validLines, orderIndex)
                    break;
                case endFn(str, filling):
                    consumeLines = this.matchQuestionOfFilling(str, orderIndex)
                    break;
                default:
                    consumeLines = this.matchQuestionOfDefault(str)
                    break;
                }
                validLines.splice(0, consumeLines)
                if (alert) {
                    alertMessage(str)
                    alert = false
                }
            }
            this.handleQuestionList()
        },
        /**
         * 计算出问卷试题的相关属性
         * @param validLines 有效行
         * @return {Object}
         */
        computedQuestionProps(validLines) {
            // 过滤掉题干
            const noStem = validLines.slice(1)
            // 如果是最后一行  就没有结束标识符了
            const resultEndIndex = noStem.findIndex(str => Object.values(QUESTION_TITLE).some(item => str.endsWith(`【${item}】`)))
            return {
                options: resultEndIndex > -1 ? noStem.slice(0, resultEndIndex).map(text => ({ text, type: "text" })) : undefined,
                stem: this.stemStr + validLines[0], // 题干
                consumeLines: resultEndIndex > -1 ? (resultEndIndex + 1) : 1 // 消费的行数
            }
        },
        /**
         * 匹配单选题
         * @param validLines 有效行
         * @param orderIndex 排序下标
         * @return {number}
         */
        matchQuestionOfSingle(validLines, orderIndex) {
            const { single } = QUESTION_VAL
            // 进入到单选模式
            this.questionStatus = single
            const {
                stem,
                options = [],
                consumeLines
            } = this.computedQuestionProps(validLines)
            this.questionList[single].push({
                type: single,
                stem: this.filterMarking(stem, QUESTION_TITLE.single),
                options,
                text: QUESTION_TITLE.single,
                order: orderIndex,
                no: uuid(5)
            })
            // 需要消费掉的有效行
            return consumeLines
        },
        /**
         * 匹配多选
         * @param validLines 有效行
         * @param orderIndex 排序下标
         * @return {number}
         */
        matchQuestionOfMultiple(validLines, orderIndex) {
            const { multiple } = QUESTION_VAL
            // 进入到多选模式
            this.questionStatus = multiple
            const {
                stem,
                options = [],
                consumeLines
            } = this.computedQuestionProps(validLines)
            this.questionList[multiple].push({
                type: multiple,
                stem: this.filterMarking(stem, QUESTION_TITLE.multiple),
                options,
                text: QUESTION_TITLE.multiple,
                order: orderIndex,
                no: uuid(5)
            })
            return consumeLines
        },
        /**
         * 匹配填空
         * @param validLine 有效行
         * @param orderIndex 排序下标
         * @return {number}
         */
        matchQuestionOfFilling(validLine, orderIndex) {
            const { filling } = QUESTION_VAL
            // 进入到填空模式
            this.questionStatus = filling
            this.questionList[filling].push({
                type: filling,
                stem: this.filterMarking(this.stemStr + validLine, QUESTION_TITLE.filling),
                options: "",
                text: QUESTION_TITLE.filling,
                order: orderIndex,
                no: uuid(5)
            })
            return 1
        },
        /**
         * 匹配默认
         * @param validLine {String} 有效行
         * @return {number}
         */
        matchQuestionOfDefault(validLine = "") {
            const {
                single,
                multiple
            } = QUESTION_VAL
            // 如果已经进入到某种试题的状态，那么就继续添加options
            if ([single, multiple].includes(this.questionStatus)) {
                const currentArray = this.questionList[this.questionStatus]
                const options = currentArray[currentArray.length - 1]?.options || []
                // 因为匹配默认的是一行一行的消费，所有每次读取第一行的数据
                options.push({ type: "text", text: validLine })
            } else {
                // 如果没有进入任何题的状态就当做题干，一直累加
                this.stemStr = this.stemStr + validLine
            }
            return 1
        },
        /**
         * 处理问卷试题列表
         * @return {undefined}
         */
        handleQuestionList() {
            const allQues = Object.values(this.questionList).flat(1)
            // 重新排序--升序排列
            allQues.sort((item1, item2) => item1.order - item2.order < 0 ? -1 : 1)
            this.allQues = allQues
            console.log(this.allQues, "allQues");
            this.$emit("matchQuestion", this.allQues)
        },

        // 获取整个责任链的状态并增加错误提示
        getChainStatusAndAlertMessage() {
            if (!Object.isObj(this.chain)) {
                this.$message.warning("请输入问卷信息")
                return "fail"
            }
            const messageMap = {
                1: "问卷欢迎语不能为空",
                2: "问卷试题不能为空"
            }
            const { allQues } = this
            const {
                single,
                multiple
            } = QUESTION_VAL
            if (this.chain.chain__status === "success") {
                if (allQues.length === 0) {
                    this.$message.warning(messageMap[1])
                    this.chain.chain__status = "fail"
                } else {
                    // 判断问卷试题是否全部满足规则
                    const errArray = []
                    const status = allQues.every((item, index) => {
                        const hasOptions = [single, multiple].includes(item.type)
                        const status = hasOptions ? !!item.options.length : true
                        if (status === false) errArray.push([index + 1, item])
                        return status
                    })
                    if (status === false) {
                        const str = errArray.reduce((preVal, curVal) => {
                            preVal = preVal + `第${curVal[0]}题（${curVal[1].text}），`
                            return preVal
                        }, "请检查")
                        this.chain.chain__status = "fail"
                        this.$message.warning(str + "是否符合规范")
                    }
                }
            } else {
                this.$message.warning(messageMap[this.chain.fail__step])
            }
            return this.chain.chain__status
        }
    }
}
</script>

<style scoped lang="less">
@import "../index";

.input {
    margin-right: 4%;

    &-text {
        float: left;
        margin-left: 30px;
        font-size: 16px;
    }

    &-example {
        float: right;
        color: @--color-primary;
        margin-right: 30px;
        font-size: 16px;
        margin-bottom: 30px;
        cursor: pointer;
    }

    &-content {
        background-color: #fff;
        min-height: 824px;
        display: block;
        color: #606266;
        padding: 30px;
        width: 100%;

        &::-webkit-input-placeholder {
            color: #C0C4CC
        }

        &:-ms-input-placeholder {
            color: #C0C4CC
        }

        &::-ms-input-placeholder {
            color: #C0C4CC
        }

        &::placeholder {
            color: #C0C4CC
        }

        &:focus {
            outline: none;
        }
    }
}
</style>
